import get from 'lodash-es/get';
import { FILE_CDN_PATH_MAP, CONTENT_METRIC_SCREENSHOT_FILE_TYPE } from '../../constants/activation-files';

const getPaths = (files, type, onlyUrl, cdnPath, additionalPath = '') => {
    if (!files) {
        return [];
    }

    const path = type ? FILE_CDN_PATH_MAP[type] + `/${additionalPath}` : additionalPath;

    return files.map((file) => {
        const url = `${cdnPath}${path}${file.name}`;
        if (onlyUrl) {
            return {
                ...file,
                url,
                path: `${path}${file.name}`
            };
        } else {
            return {
                ...file,
                name: file.original_name,
                mime: file.mime_type,
                url,
                path: `${path}${file.name}`
            };
        }
    });
};

export const getFilePaths = (files, type = null, onlyUrl = false) => getPaths(files, type, onlyUrl, grinEnv.CDN_CLIENT);
export const getMediaLibraryFilePaths = (files, type = null, onlyUrl = true) =>
    getPaths(files, type, onlyUrl, grinEnv.CDN_MEDIA_LIBRARY);
export const getContentMetricScreenshotFilePaths = (files, customPath = '') => {
    return getPaths(
        files,
        null,
        true,
        grinEnv.CDN_MEDIA_LIBRARY,
        `${FILE_CDN_PATH_MAP[CONTENT_METRIC_SCREENSHOT_FILE_TYPE]}/${customPath}`
    );
};

export const getActivationFiles = (brief, type) => {
    const files = get(brief, 'files', []);

    return getFilePaths(
        files.filter((file) => file.type === type),
        type
    );
};
